import React from 'react';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Avatar, AvatarRadii } from 'components/Avatar';

import dashboardStyles from '../Dashboard.module.scss';

const OrgList = ({ orgs, device }) => {
  const { t } = useTranslation('dashboard');
  const router = useRouter();

  const navigateToOrg = (orgId) => {
    router.push(`organizations/${orgId}/dashboard`);
  };

  return (
    <div className={classnames('bn-container', 'min-h-[115px]', device)}>
      <div className={dashboardStyles.cardHeader}>
        <span className={dashboardStyles.cardTitle}>
          {t('organizations.title')}
        </span>
      </div>
      <div>
        {orgs.map((org) => (
          <div
            key={`${org.id}-${org.name}`}
            className="flex items-center cursor-pointer py-4 px-3 hover:bg-primary-50 overflow-hidden gap-2"
            role="button"
            onClick={() => navigateToOrg(org.id)}
          >
            <div>
              <Avatar src={org.badgeImageUrl} radius={AvatarRadii.Lg} />
            </div>
            <div className="flex-1 flex flex-col overflow-hidden">
              <p className="font-bold">{org.name}</p>
              <p className="text-ellipsis whitespace-nowrap overflow-hidden">
                {org.address}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  self: state.user.user
});

export default connect(mapStateToProps)(OrgList);
